import { Text } from "@meditect/medibase-components";

export const SalesCannotCloseSaleFromBeninPharmacyWithoutMCFTokenError = () => {
  return <Text>Token e-MECeF non défini ou incorrect</Text>;
};
